module.exports = __webpack_public_path__ + "static/img/1_1_3.63186d9f.png";